import { defineComponent as _defineComponent } from 'vue'
import { ButtonHTMLAttributes, computed, useAttrs, type Component } from 'vue';


const __default__ = { inheritAttrs: false };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'ReportActionButton',
  props: {
    icon: null,
    type: null,
    disabled: { type: Boolean },
    loading: { type: Boolean },
    ariaLabel: null,
    label: null
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'click', event: MouseEvent): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  icon?: Component;
  type?: ButtonHTMLAttributes['type'];
  disabled?: boolean;
  loading?: boolean;
  ariaLabel?: string;
  /** Tooltip text shown on hover; when omitted, no tooltip is rendered */
  label?: string;
};





const attrs = useAttrs();

const isDisabled = computed(() => props.disabled || props.loading);

const computedAriaLabel = computed(() => props.ariaLabel || props.label);

const filteredAttrs = computed(() => {
  const { disabled, type, ...rest } = attrs;
  return rest;
});

const handleClick = (e: MouseEvent) => {
  if (isDisabled.value) return;
  emit('click', e);
};

return { __sfc: true,props, emit, attrs, isDisabled, computedAriaLabel, filteredAttrs, handleClick }
}

})